export default "__VITE_ASSET__$eJPQjf1__"